module.exports = __webpack_public_path__ + "static/img/cogneti.cd44665.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/cogneti.svg
// module id = 327
// module chunks = 4